import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { map } from "rxjs/operators";
import { SidePanelBase } from "../../../../common/components/side-panel-base.class";
import { LandownerPassthroughProgramNote } from "../../../../common/models/permit.model";
import { SidePanelService } from '../../../../common/services/side-panel.service';
import { PermitService } from "../../../../common/services/permit.service";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";

@Component({
    selector: 'app-program-notes',
    templateUrl: './program-notes.component.html',
    styleUrls: ['./program-notes.component.scss'],
    standalone: false
})
export class ProgramNotesComponent extends SidePanelBase implements OnInit, OnDestroy {
    static componentName = "ProgramNotesComponent";

    applicationId: string;

    editorOpen: boolean = false;

    editorOptions: any = {
        heightMax: 200,
        height: 200,
        heightMin: 150,
        saveInterval: 0,
        toolbarButtons: ["fullScreen", "html", "undo", "redo", "bold", "italic", "underline", 'strikeThrough', "align", "fontSize", "paragraphFormat", "indent", "color"],
        typingTimer: 150,
        autofocus: true
    }

    notes: LandownerPassthroughProgramNote[];

    notesForm: FormGroup = new FormGroup({});

    notesSaving: boolean = false;



    subscription: Subscription = new Subscription();

    constructor(private service: SidePanelService, private permitService: PermitService, private dialogService: DynamicDialogService) {
        super();
    }

    ngOnInit() {
        const data$ = this.service.update().pipe(
            map((data: any) => {
                if (data != null && data.data != null) {
                    const sections = data.data.sections;
                    if (sections != null && sections.length > 1) {
                        this.notes = sections[0].componentData.notes as LandownerPassthroughProgramNote[];
                        this.applicationId = sections[0].componentData.applicationId;
                    }
                }
                return this.notes
            })
        ).subscribe(
            (notes: LandownerPassthroughProgramNote[]) => {
                if (this.notes != null) {
                    this.notes = notes.sort((a, b) => {
                        if (a.dateCreated < b.dateCreated) return -1;
                        if (a.dateCreated > b.dateCreated) return 1;
                        return 0;
                    });
                }               
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(data$);
        if (this.componentData != null) {
            this.notes = this.componentData.notes;
            this.applicationId = this.componentData.applicationId;
        }
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    addComment(): void {
        let note: LandownerPassthroughProgramNote = {
            applicationId: this.applicationId,
            comment: this.notesForm.get('content').value,
        }
        this.notesSaving = true;
        let save$ = this.permitService.addLandownerApplicationNote(note).pipe(            
            finalize(() => {
                this.notesSaving = false;
            })
        ).subscribe(
            (saved: LandownerPassthroughProgramNote) => {
                if (this.notes == null) this.notes = [];
                this.notes.push(saved);
                this.notesForm.reset();
            },
            (error) => {
                console.error(error);
                this.dialogService.showError();
            }
        );
        this.subscription.add(save$);
    }

    notesFormBuilt(builtForm: FormGroup): void {
        this.notesForm = builtForm;
    }

}
